import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { switchMap, catchError } from 'rxjs';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(CalAngularService);

  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  return authService.getAADToken([`${environment.clientId}/.default`], false).pipe(
    switchMap((token) => {
      if (token && typeof token === 'string') {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next(authReq);
      }
      return next(req);
    }),
    catchError((err) => {
      console.error('Failed to acquire token:', err);
      return next(req);
    })
  );
};
